import { Component, ChangeDetectionStrategy } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { HttpClient } from "@angular/common/http";
import { RouterOutlet } from "@angular/router";

@Component({
    selector: "my-app", // <my-app></my-app>
    templateUrl: "./app.component.html",
    styleUrls: ["./app.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [RouterOutlet]
})
export class AppComponent {
    constructor(public translate: TranslateService, public http: HttpClient) {
        translate.addLangs(["en", "de"]);
        if (navigator.language === "de") {
            translate.use("de");
        } else {
            translate.use("en");
        }
    }
}
